selectDetailContentSubtype